import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { DoublePurchaseApiClient } from '../../api-clients';
const {
  Provider,
  ...client
} = DoublePurchaseApiClient;
export const DoublePurchaseExtension = createModuleExtension({
  extensionName: 'doublePurchaseExtension',
  Provider,
  SDK: {
    doublePurchaseApiClient: client
  }
});
//# sourceMappingURL=double-purchase.extension.js.map